"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_i18next_1 = require("react-i18next");
const svgs_1 = require("@@/assets/svgs");
const api_1 = require("@/api");
const errors_1 = require("@/common/errors");
const Button_1 = __importDefault(require("@mui/material/Button"));
const CircularProgress_1 = __importDefault(require("@mui/material/CircularProgress"));
function default_1({ isInputMode, setIsInputMode, expenseRecordForm, roomId, }) {
    const fieldsToChange = [
        'total_settlement_amount',
        'production_cost',
        'packaging_cost',
        'delivery_cost',
        'labor_cost',
        'rent_cost',
        'donation_cost',
        'other_cost_1',
        'other_cost_2',
    ];
    const fieldsToKeep = [
        'production_cost_filename',
        'packaging_cost_filename',
        'delivery_cost_filename',
        'labor_cost_filename',
        'rent_cost_filename',
        'donation_cost_filename',
        'other_cost_1_filename',
        'other_cost_2_filename',
    ];
    const resetFieldsOnFinish = (patchedData = {}) => {
        const defaultInputs = {};
        const defaultValues = expenseRecordForm.formState.defaultValues;
        if (defaultValues) {
            fieldsToChange.forEach(inputKeys => {
                Object.assign(defaultInputs, { [inputKeys]: defaultValues[inputKeys] });
            });
        }
        // ! 파일 업로드는 reset하지 않기 (파일의 업로드 및 삭제는 취소시 변경되지 않음)
        const currentFiles = {};
        const fileNames = expenseRecordForm.getValues(fieldsToKeep);
        fileNames.forEach((fileName, index) => {
            Object.assign(currentFiles, { [fieldsToKeep[index]]: fileName });
        });
        expenseRecordForm.reset(Object.assign(Object.assign(Object.assign({}, defaultInputs), currentFiles), patchedData));
        setIsInputMode(false);
    };
    const isEditedBefore = () => [...fieldsToChange, ...fieldsToKeep].some(fieldName => !!expenseRecordForm.watch(fieldName));
    const [isSubmitting, setIsSubmitting] = (0, react_1.useState)(false);
    const submitExpenseInput = (costInputs) => __awaiter(this, void 0, void 0, function* () {
        const dirtyFields = Object.keys(expenseRecordForm.formState.dirtyFields);
        if (!dirtyFields.length) {
            setIsInputMode(false);
        }
        else {
            setIsSubmitting(true);
            const dataToPatch = {};
            dirtyFields.forEach(fieldName => {
                Object.assign(dataToPatch, { [fieldName]: costInputs[fieldName] });
            });
            yield (0, api_1.patchData)(`/api/v1/room/${roomId}/settlement-manage/expense-cost`, dataToPatch)
                .then(() => resetFieldsOnFinish(dataToPatch))
                .catch(err => {
                const { status } = err.response;
                if (status === 403)
                    (0, errors_1.handle403Error)(err);
                else
                    alert((0, errors_1.commonErrorMsg)(status));
            })
                .finally(() => setIsSubmitting(false));
        }
    });
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: "expense_record_register" }, { children: isInputMode ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ onClick: () => resetFieldsOnFinish(), sx: {
                        border: '1px solid var(--gray-10)',
                        color: 'var(--gray-80)',
                        bgcolor: 'var(--white) !important',
                    } }, { children: t('취소') }), "record_register_cancel_btn"), (0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ disabled: isSubmitting, onClick: expenseRecordForm.handleSubmit(submitExpenseInput), sx: {
                        color: 'var(--white)',
                        bgcolor: 'var(--primary-main) !important',
                        fontWeight: 'bold',
                    } }, { children: isSubmitting ? ((0, jsx_runtime_1.jsx)(CircularProgress_1.default, { size: 16, color: "info", thickness: 4 })) : ((0, jsx_runtime_1.jsx)("span", { children: t('저장') })) }), "record_register_save_btn")] })) : ((0, jsx_runtime_1.jsxs)(Button_1.default, Object.assign({ onClick: () => setIsInputMode(true), sx: {
                border: '1px solid var(--gray-80)',
                color: 'var(--gray-80)',
                bgcolor: 'var(--white) !important',
                fontWeight: 'bold',
            } }, { children: [(0, jsx_runtime_1.jsx)(svgs_1.EditIconSvg, {}), isEditedBefore() ? (0, jsx_runtime_1.jsx)("span", { children: t('수정') }) : (0, jsx_runtime_1.jsx)("span", { children: t('등록') })] }), "record_register_enable_input_btn")) })));
}
exports.default = default_1;
